import { Suspense } from "react";
import { Outlet } from "react-router";
import { SiteHeader } from "./SiteHeader";
import { SketchBackground } from "./SketchBackground";
import { SiteFooter } from "./SiteFooter";
import { FullPageSpinner } from "@/components/ui";
import { useVisitBeacon } from "@/lib/useVisitBeacon";

export function SiteLayout() {
  // Public pages only: the admin shell is not a visit.
  useVisitBeacon();

  return (
    <>
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <SketchBackground />
      <SiteHeader />
      <main id="main" className="page">
        <Suspense fallback={<FullPageSpinner />}>
          <Outlet />
        </Suspense>
      </main>
      <SiteFooter />
    </>
  );
}
